import { TEC_CONDUZIONE_CANTIERE } from 'constants/ProjectsConstant';
import { GENERIC_TASKS, TECHNICIAN_TASKS } from './CommonTasks';

export const TEC_CONDUZIONE_CANTIERE_STEPS = [
  {
    code: TEC_CONDUZIONE_CANTIERE,
    icon: null,
    order: 1,
  },
];

export const TEC_CONDUZIONE_CANTIERE_TASKS = [...TECHNICIAN_TASKS, ...GENERIC_TASKS];
